import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Box, MainHeading, BoxContent, NoData} from '../../StyledComponents';
import Slider from 'rc-slider';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import Toggle from 'material-ui/Toggle';

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

const PriceIndexViewContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;

  @media only screen and (max-width: 991px), print {
    min-height: 400px;
  }

  @media only screen and (max-width: 524px) {
    min-height: 350px;
  }
`;

const ScoreHeading = styled.h1`
  margin-bottom: 0px;
  margin-top: 0;
`;

const ScoreLabelContainer = styled.div`
 &:hover {
      z-index: 999999;
    }

  &:after {
    position:absolute;
    content:"\00a0";
    display:block;
    left:-25px;
    width:13px;
    height:13px;
    margin-top: -17px;
  }
  &.index:after {
    background:#d06768
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  &.score:after {
    background:#5ab99a;
    border-radius:50%;
    z-index: 99999;
  }
  &.average:after {
    background:#fd7923;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  &.competitor:after {
    background:#cf6768;
  }


`;

const ScoreLabel = styled.div`
  text-align: left;
  color: #fff;
  white-space: nowrap;
  padding: 2px 5px;
  text-transform: capitalize;
  &:hover {
      z-index: 999999;
    }
  /*
  &.score {
      background:#5ab99a;
      z-index:999;
  }

  &.average {
      background:#fd7923;
  }

  &.index {
      background:#d06768;
  }

  &.competitor {
      background:#cf6768;
     }
*/
  &.score:hover {
      z-index: 999999;
    }

  ${props => props.leftAlign && css`
    position: relative;
    left: calc(-100% - 35px);
  `}

`;

const PriceIndexRange = styled(Range)`
  background: transparent;
  left: calc(50%);
  transform: translateX(-50%);
`;

const SmallLabel = styled.span`
  font-size:11px;
`;

const toggleStyles = {
  block: {
    maxWidth: 250,
    float: 'right',
  },
  toggle: {
    marginBottom: 16,
  },
  thumbOff: {
    backgroundColor: '#fff',
  },
  trackOff: {
    backgroundColor: '#999',
  },
  thumbSwitched: {
    backgroundColor: '#fff',
  },
  trackSwitched: {
    backgroundColor: '#5ab99a',
  },
  labelStyle: {
    color: 'white',
    fontWeight:'normal',
    opacity:0.5
  },
};

class BrandRelevancePosition extends Component {
    constructor(props) {
        super(props);
        this.state = {
          showCompetitors: true
        };
    }


    getSliderValues(data) {
      //let values = [parseFloat(data.value), 50, 100];
      let values =[10,20,30]
      /*
      if (this.state && this.state.showCompetitors) {
        let competitors = data.competitors;

        _.map(competitors, (comp, key) => {
          values.push(comp.value);
        });
      };
      */

      return values;
    }

    getSliderMarks(data, competitors) {
      let clientName =  this.props.user.client && this.props.user.client.name;
      let disableBrandPositionRelevanceTarget = this.props.user.client && this.props.user.client.settings && this.props.user.client.settings.disableBrandPositionRelevanceTarget;
      let target = data.target;
      let index = data.index;
      let score = data.value;

      function sortNumber(a,b) {
        return a - b;
      }

      let allValues =[target,index,score];
      allValues = _.compact(allValues);
      allValues.sort(sortNumber);

      let leftAlign = function(val) {
        return allValues.indexOf(val) %2 === 0;
      };

      let marks = {};

      if (target && !disableBrandPositionRelevanceTarget) {
        marks[parseFloat(target)] ={
          label: <ScoreLabelContainer className="average"><ScoreLabel leftAlign={leftAlign(99)} className="average small-font-size">WHERE YOU WANT TO BE: {target}</ScoreLabel></ScoreLabelContainer>,
        };
      }

      {/*
      if (index) {
        marks[parseFloat(index)] ={
          label: <ScoreLabelContainer className="index"><ScoreLabel leftAlign={true} className="index small-font-size">INDUSTRY INDEX: {index}</ScoreLabel></ScoreLabelContainer>,
        };
      }
      */}

      if (score) {
        marks[parseFloat(score)] = {
          label: <ScoreLabelContainer className="score"><ScoreLabel leftAlign={leftAlign(score)} className="score small-font-size">YOUR POSITION: {score}</ScoreLabel></ScoreLabelContainer>,
        };
      };


      if (this.state.showCompetitors) {
         _.each(competitors, function(comp, i) {
          if (clientName && comp.name != clientName.toLowerCase()) {
            marks[parseFloat(comp.value)] = {
              label: <ScoreLabelContainer className="competitor"><ScoreLabel leftAlign={i%2===0} className="competitor small-font-size">{comp.name}: {comp.value}</ScoreLabel></ScoreLabelContainer>,
            };
          }
        })
      }

      return marks;
    }

    toggleCompetitors(e, val) {
      this.setState({showCompetitors: val});
    }

    render() {
      const { data, printBreak } = this.props;
      const disabledViews = this.props.user.client && this.props.user.client.viewSettings && this.props.user.client.viewSettings.disabledViews || [];

      if (!data || !data.variableData) {
        return <Box><MainHeading className="text-left">Brand Relevance</MainHeading></Box>;
      }

      let score = data.variableData.nscore || data.variableData.score || 0;

      if (data.variableData.nscore === 0) {
          score = data.variableData.nscore;
      }

      score = parseFloat(score).toFixed(2);
      const target = data.variableData.targetScore ? parseFloat(data.variableData.targetScore).toFixed(2) : null;

      const index = data.variableData.index ? parseFloat(data.variableData.index).toFixed(2) : null;

      const relevanceData = data.variableData.brand && data.variableData.brand.relevance || {};
      const competitors = [];
      for (var brand in relevanceData) {
        competitors.push({name: brand, value: parseFloat(relevanceData[brand]).toFixed(2)})
      }

      const prepData = {
        "value": score,
        "target": target,
        "index": index,
      };

      const disabled = disabledViews.indexOf(this.props.id) > -1;
      const _data = prepData;
      const values = [parseFloat(_data.value), parseFloat(_data.target)];
      _.forEach(competitors, function(obj,i) {
        values.push(parseFloat(obj.value));
      });

      const min = parseInt(Math.min(score, target, index) - 1);
      const max = parseInt(Math.max(...values)+2);

      return (
        <Box className={printBreak ? 'print-page-break-after' : ''}>
          <PriceIndexViewContainer>
            <div className="text-center priceIndexComponent">
                <MainHeading className="text-left">Brand Relevance</MainHeading>
              <BoxContent disabled={disabled}>
                <span className="small-font-size">Your position</span>
                <ScoreHeading className="super-large-font-size">{_data && _data.value}</ScoreHeading>

                <div style={toggleStyles.block}>
                  <Toggle
                    className="small-font-size"
                    label="Competitors"
                    step={0.1}
                    style={toggleStyles.toggle}
                    labelStyle={toggleStyles.labelStyle}
                    thumbStyle={toggleStyles.thumbOff}
                    trackStyle={toggleStyles.trackOff}
                    thumbSwitchedStyle={toggleStyles.thumbSwitched}
                    trackSwitchedStyle={toggleStyles.trackSwitched}
                    toggled={this.state.showCompetitors}
                    onToggle={(e, val) => this.toggleCompetitors(e,val)}
                  />
                </div>

                <div style={{position:'absolute',top:'130px',bottom:'60px', left:'0',right:'0',marginLeft:'auto',marginRight:'auto', overflow: 'hidden'}}>
                  <SmallLabel className="small-font-size">{/* max */}</SmallLabel>

                  {_data && (
                    <PriceIndexRange
                      disabled
                      vertical
                      count={3}
                      value={this.getSliderValues(_data)}
                      className="priceIndexSlider"
                      trackStyle={[{backgroundColor: 'transparent' }]}
                      railStyle={{ backgroundColor: '#b7b7b7' }}
                      handleStyle={[{display:'none'}]}
                      min={min}
                      max={max}
                      marks={this.getSliderMarks(_data, competitors)}
                    />

                  )}
                  <SmallLabel className="small-font-size">{/* min */}</SmallLabel>
                </div>
              </BoxContent>
              {disabled && <NoData/>}
            </div>
          </PriceIndexViewContainer>
        </Box>
      );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid,
        data: state.data,
        user: state.user
    };
}

export default connect(mapStateToProps)(BrandRelevancePosition);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/BrandRelevancePosition.js